import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formData: {
    title: "",
    description: "",
    category: "",
    language: "",
    country: "",
    releaseYear: "",
    cast:[],
    crew:[],
    classifications: [],
    trailerTitle:"",
    basicInfo:{
      duration:"",
      ageRating:"",
      synopsis:"",
    },
    
  },
  isSubmitted: false
};

export const movieboxSlice = createSlice({
  name: 'moviebox',
  initialState,
  reducers: {
    saveFormData: (state, action) => {
      state.formData = action.payload;
      state.isSubmitted = true;
    },
    resetFormData: (state) => {
      state.formData = initialState.formData;
      state.isSubmitted = false;
    }
  }
});

export const { saveFormData, resetFormData } = movieboxSlice.actions;

export default movieboxSlice.reducer;